_ = require("lodash")
$ = require("jquery")

isSupportedCourse = (course) ->
  return true unless course
  return true if course.club.ext_type is "yourgolf2"
  return false

IndexCtrl = ($scope, AnalysisService, goalSettings, $analytics, $routeParams, $filter, userInfo) ->
  $analytics.eventTrack('ANL_loaded')

  createViewModel = ->
    AnalysisService.convertScoreCards $scope.scorecards,
      startDate: $scope.startDate
      endDate: $scope.endDate
      course: $scope.course
      roundType: $scope.roundType

  createMyAnalysisParams = (course, roundType) ->
    from: $scope.startDate
    to: $scope.endDate
    course: course?.course
    round_type: roundType

  callMyAnalysis = (course, roundType) ->
    params = createMyAnalysisParams(course, roundType)
    $scope.isLoadingDetailedAnalysis = true

    AnalysisService.getMyAnalysis(params).then (myAnalysis) ->
      $scope.$broadcast "myAnalysisUpdated.gnp.analysis", myAnalysis
    .finally ->
      $scope.isLoadingDetailedAnalysis = false

  $scope.activeDisplay = (tab) ->
    $scope.tab = tab
    if $scope.tab == 1
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.GOAL')
      $scope.classTitle = "goal"
    else if $scope.tab == 2
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG')
      $scope.classTitle = "avg"
    else if $scope.tab == 3
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.BEST_SCORE')
      $scope.classTitle = "best"
    else if $scope.tab == 4
      $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.WORST_SCORE')
      $scope.classTitle = "worst"

  $scope.disableCourseStats = false
  if $routeParams.user_id != undefined

    $scope.hideNoResultMsg = true

  $scope.course = undefined
  $scope.roundType = [0.5, 1, 1.5]
  $scope.goalSettings = goalSettings
  $scope.scorecards = []
  $scope.startDate = undefined
  $scope.endDate = undefined
  $scope.isShowDetailedAnalysis = true
  $scope.isLoadingScoreCards = true
  $scope.isLoadingDetailedAnalysis = true
  $scope.isLoadingMap = true #This flag is used for Course List section to avoid clicking while google map is loading
  $scope.showNoResultMsg = false
  $scope.hideHeader = false
  $scope.classTitle = "avg"
  $scope.nameSort = $filter('translate')('_ANALYSIS_EVENT.DETAILED_ANALYSIS.MY_AVG')
  $scope.userInfo = userInfo

  # Try to handle swipe map with two fingers's problem
  $('#map_canvas').on 'touchstart click dblclick touchmove touchend wheel mousewheel DOMMouseScroll', (e) ->
    e.preventDefault()
    return

  $('body').bind 'touchmove', (e) ->
    e.preventDefault()
    return

  if $routeParams.hide_header == '1'
    $scope.hideHeader = true
    $scope.disableCourseStats = true

  $scope.$on "mapLoaded.gnp.analysis", ->
    $scope.isLoadingMap = false

  $scope.$on "courseChanged.gnp.analysis", (event, course) ->
    #Track course to use in 'periodSelected.gnp.analysis'
    $scope.course = course
    viewModel = createViewModel()
    $scope.$broadcast "filteredScorecardsUpdated.gnp.analysis", viewModel.filteredScorecards
    $scope.$broadcast "selectedCourseUpdated.gnp.analysis", course
    $scope.isShowDetailedAnalysis = false
    return unless isSupportedCourse(course)
    $scope.isShowDetailedAnalysis = true
    callMyAnalysis(course, $scope.roundType)

  $scope.$on "periodSelected.gnp.analysis", (event, startDate, endDate, roundType) ->
    #clone to avoid reference data from events
    $scope.startDate =  startDate?.clone()
    $scope.endDate = endDate?.clone()
    $scope.roundType = roundType
    viewModel = createViewModel()
    $scope.$broadcast "coursesUpdated.gnp.analysis", viewModel.courses
    $scope.$broadcast "clubsUpdated.gnp.analysis", viewModel.clubs
    $scope.$broadcast "filteredScorecardsUpdated.gnp.analysis", viewModel.filteredScorecards

  $scope.$on "roundTypeUpdated.gnp.analysis", (event, roundType) ->
    $scope.roundType = roundType
    viewModel = createViewModel()
    callMyAnalysis($scope.course, roundType)
    $scope.$broadcast "coursesUpdated.gnp.analysis", viewModel.courses
    $scope.$broadcast "clubsUpdated.gnp.analysis", viewModel.clubs
    $scope.$broadcast "filteredScorecardsUpdated.gnp.analysis", viewModel.filteredScorecards

  AnalysisService.getScoreCards().then (res) ->
    $scope.scorecards = res.data.score_cards
    $scope.showNoResultMsg = $scope.scorecards.length is 0
    $scope.$emit "periodSelected.gnp.analysis", $scope.startDate, $scope.endDate
  .finally ->
    $scope.isLoadingScoreCards = false

IndexCtrl.$inject = [
  '$scope'
  'AnalysisService'
  'goalSettings'
  '$analytics'
  '$routeParams'
  '$filter'
  'userInfo'
]

module.exports = IndexCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/index-controller.coffee